import type { ToolDefinitionAction } from '@/services/toolDefinition.service';
import type { CustomToolDraft } from './custom-tool-draft';
import { CUSTOM_PROVIDER } from './paths';
import type { StepTools } from './use-step-tools';

/** The draft in the shape a tool definition has, so the signature card and the argument form read it like any tool. */
export const draftToolAction = (draft: CustomToolDraft, stepTools: StepTools, writes: boolean): ToolDefinitionAction => ({
	id: 'preview',
	label: draft.name.trim() || 'Your custom tool',
	provider: CUSTOM_PROVIDER,
	color: 'blue',
	tool: draft.slug || 'your_custom_tool',
	description: draft.description.trim() || 'The description you write is what the AI reads here.',
	riskLevel: writes ? 'high' : 'low',
	inputSchema: {
		type: 'object',
		properties: Object.fromEntries(
			draft.inputs.map((input) => [input.name, { type: input.type, ...(input.description ? { description: input.description } : {}) }])
		),
		required: draft.inputs.filter((input) => input.required).map((input) => input.name)
	},
	outputSchema: {
		type: 'object',
		properties: Object.fromEntries(
			draft.steps.map((step) => [step.id, { type: 'object', description: `Status and result of ${stepTools.toolFor(step)?.label ?? step.tool}` }])
		)
	}
});
